import { render, staticRenderFns } from "./PerformerExperimentalShow.vue?vue&type=template&id=3ddf8b0c&scoped=true&"
import script from "./PerformerExperimentalShow.vue?vue&type=script&lang=js&"
export * from "./PerformerExperimentalShow.vue?vue&type=script&lang=js&"
import style0 from "./PerformerExperimentalShow.vue?vue&type=style&index=0&id=3ddf8b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf8b0c",
  null
  
)

export default component.exports